/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Checkout_Seller_Complaints_NoticeInputs */

const en_checkout_seller_complaints_notice = /** @type {(inputs: Checkout_Seller_Complaints_NoticeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Complaints can be sent in writing to ${i?.email} within 48 hours of check-out; we acknowledge within one business day.`)
};

/**
* | output |
* | --- |
* | "Complaints can be sent in writing to {email} within 48 hours of check-out; we acknowledge within one business day." |
*
* @param {Checkout_Seller_Complaints_NoticeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const checkout_seller_complaints_notice = /** @type {((inputs: Checkout_Seller_Complaints_NoticeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkout_Seller_Complaints_NoticeInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_checkout_seller_complaints_notice(inputs)
});